<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <b-container>
      <b-row align-v="center">
        <b-col cols="auto">
          <v-btn class="btn-return" @click="$router.go(-1)">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i>
            VOLTAR
          </v-btn>
        </b-col>
        <b-col>
          <h1 class="title-pages">SEGURANÇA</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card title="DISPOSITIVOS">
            <b-form-group>
              <b-checkbox
                v-model="allowed_devices_active"
                :value="1"
                :unchecked-value="0"
              >
                CONTROLE DE DIPOSITIVOS
              </b-checkbox>
              <template #description>
                SOMENTE DISPOSITIVOS PREVIAMENTE AUTORIZADOS PODERÃO FAZER LOGIN
              </template>
            </b-form-group>
          </b-card>
        </b-col>
      </b-row>
      <errors-messages :errors="errors" />
      <b-row align-h="end">
        <b-col cols="auto">
          <confirmation-dialog
            message-title="CONFIRMAÇÃO"
            message-body="TEM CERTEZA QUE DESEJA SALVAR?"
            open-class="btn-save"
            open-text="SALVAR"
            openLeftIcon="fa-check"
            @yes="save"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog";

import api from "../services/api";

import toast from "../lib/ToastNotification";

export default {
  name: "Security",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    ConfirmationDialog,
  },

  data() {
    return {
      errors: [],

      settings: null,
      allowed_devices_active: 0,

      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  watch: {
    settings() {
      if (!this.settings) return;

      const keys = Object.keys(this.settings);
      for (const key of keys) this[key] = this.settings[key];
    },
  },

  methods: {
    async retrieve() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/settings/security");
        const { error, errors, settings } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.settings = settings;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async save() {
      try {
        this.loading = true;

        const data = { allowed_devices_active: this.allowed_devices_active };
        const response = await api.patch("/rest-home/settings/security", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message);
          this.retrieve().then();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
